import { z } from "zod/v4";

import { AiNodeContextSchema } from "../context-schemas";
import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import {
  BaseNodeDefinitionConfigSchema,
  BaseNodeDefinitionSchema,
} from "./base-node";

// Schema for the object structure that will be generated
export const LLMObjectSchemaConfigSchema = z.object({
  schema: z.record(z.string(), z.any()), // JSON schema for the object structure
});

// Zod schema for LLMObjectNodeResult
export const LLMObjectNodeResultSchema = BaseNodeExecutionResultSchema.extend({
  type: z.literal("llm-object"),
  updatedContext: AiNodeContextSchema,
  generatedObject: z.any(), // The generated object from AI
});

// Zod schema for LLMObjectNodeConfig
export const LLMObjectNodeConfigSchema = BaseNodeDefinitionConfigSchema.and(
  z
    .object({
      systemPrompt: z.string(),
      userPrompt: z.string(),
      temperature: z.number(),
      maxRetries: z.number().optional(),
      outputVariableName: z.string(), // Variable name to store the generated object
    })
    .and(LLMObjectSchemaConfigSchema)
);

// Zod schema for LLMObjectNodeDefinition
export const LLMObjectNodeDefinitionSchema = BaseNodeDefinitionSchema.extend({
  type: z.literal("llm-object"),
  config: LLMObjectNodeConfigSchema,
});

// Inferred types from Zod schemas
export type LLMObjectNodeResult = z.infer<typeof LLMObjectNodeResultSchema>;
export type LLMObjectNodeDefinition = z.infer<
  typeof LLMObjectNodeDefinitionSchema
>;
export type LLMObjectNodeConfig = z.infer<typeof LLMObjectNodeConfigSchema>;
export type LLMObjectSchemaConfig = z.infer<typeof LLMObjectSchemaConfigSchema>;
